import { render } from "./dialogNotification.vue?vue&type=template&id=49640d35"
import script from "./dialogNotification.vue?vue&type=script&lang=js"
export * from "./dialogNotification.vue?vue&type=script&lang=js"

import "./dialogNotification.vue?vue&type=style&index=0&id=49640d35&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__